import { useState } from "react";
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";
import { InviteUserDialog } from "./InviteUserDialog";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useTranslation } from "react-i18next";

interface InviteUserButtonProps {
  variant?: "default" | "outline" | "ghost" | "link";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
  children?: React.ReactNode;
  iconOnly?: boolean;
  asMenuItem?: boolean;
}

export function InviteUserButton({ 
  variant = "default", 
  size = "default", 
  className,
  children,
  iconOnly = false,
  asMenuItem = false
}: InviteUserButtonProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { t } = useTranslation();

  const label = children || t('user.inviteUser', 'Invite User');

  if (asMenuItem) {
    return (
      <>
        <DropdownMenuItem 
          onSelect={(e) => {
            e.preventDefault();
            setIsDialogOpen(true);
          }}
        >
          <UserPlus className="mr-2 h-4 w-4" />
          {label}
        </DropdownMenuItem>
        <InviteUserDialog
          open={isDialogOpen}
          onOpenChange={setIsDialogOpen}
        />
      </>
    );
  }

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={() => setIsDialogOpen(true)}
      >
        <UserPlus className={iconOnly ? "h-4 w-4" : "h-4 w-4 mr-2"} />
        {!iconOnly && (
          <>
            <span className="hidden sm:inline">{label}</span>
            <span className="sr-only sm:hidden">{label}</span>
          </>
        )}
        {iconOnly && <span className="sr-only">{label}</span>}
      </Button>
      
      <InviteUserDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />
    </>
  );
}
